const params = [
  {
    programs: "Nondegree-seeking Graduate",
    value: 0,
  },
];

export default params;
